import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

import { Box, Container, Typography, useTheme } from '@mui/material'
import ButterflyTattoo from 'assets/images/butterfly_tattoo.jpeg'
import Anna from 'assets/images/for-artists/anna.webp'
import EyeTattoo from 'assets/images/for-artists/eye-tattoo.png'
import RoseTattoo from 'assets/images/rose_tattoo.png'
import ArtistCard from 'components/common/cards/ArtistCardNew/ArtistCardNew'
import { Navigation, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

const heroCardData = {
  image: Anna,
  first_name: 'Anna',
  last_name: 'Smith',
  studio: [
    { city: 'Zurich', country: 'Swizterland' },
    { city: 'Berlin', country: 'Germany' },
  ],
  style: [{ name: 'Geometric' }, { name: 'Arabic' }],
  tattoo: [
    { image_medium: RoseTattoo, tattoo_uid: 'rose' },
    { image_medium: EyeTattoo, tattoo_uid: 'eye' },
    { image_medium: ButterflyTattoo, tattoo_uid: 'butterfly' },
  ],
}

const SectionArtists = () => {
  const { palette } = useTheme()

  return (
    <Container maxWidth="xl" sx={{ padding: '4rem' }}>
      <Typography variant="h5" sx={{ color: ' white', padding: '1.5rem 0' }}>
        Meet artists on inckd.
      </Typography>
      <Box
        sx={{
          '.swiper': { padding: '2rem 0' },
          '.swiper-pagination': { bottom: 0, marginTop: '2rem' },
          '.swiper-pagination-bullet': {
            backgroundColor: palette.primary.lightest,
          },
          '.swiper-pagination-bullet-active': {
            backgroundColor: palette.primary.light,
          },
          '.swiper-button-next': {
            backdropFilter: 'blur(1px)',
            width: '4rem',
            height: '100%',
            top: 0,
            right: 0,
            color: `${palette.primary.light} !important`,
            '&:hover': {
              color: `${palette.primary.main} !important`,
            },
          },
          '.swiper-button-prev': {
            backdropFilter: 'blur(1px)',
            width: '4rem',
            height: '100%',
            left: 0,
            top: 0,
            color: `${palette.primary.light} !important`,
            '&:hover': {
              color: `${palette.primary.main} !important`,
            },
          },
        }}
      >
        <Swiper
          spaceBetween={16}
          slidesPerView={3.33}
          modules={[Navigation, Pagination]}
          navigation
          pagination={{ clickable: true }}
        >
          <SwiperSlide>
            <ArtistCard
              variant="hero"
              data={heroCardData}
              locationFilter={null}
              styleFilter={null}
            />
          </SwiperSlide>
          <SwiperSlide>
            <ArtistCard
              variant="hero"
              data={heroCardData}
              locationFilter={null}
              styleFilter={null}
            />
          </SwiperSlide>
          <SwiperSlide>
            <ArtistCard
              variant="hero"
              data={heroCardData}
              locationFilter={null}
              styleFilter={null}
            />
          </SwiperSlide>
          <SwiperSlide>
            <ArtistCard
              variant="hero"
              data={heroCardData}
              locationFilter={null}
              styleFilter={null}
            />
          </SwiperSlide>
          ...
        </Swiper>
      </Box>
    </Container>
  )
}

export default SectionArtists
